import React from "react";
import dayjs from "dayjs";
import { Checkbox, DatePicker, Input, Select } from "antd";
import { filterOptionForSearch } from "../../../../../../utils/filterUtils";
import { DateFormat } from "../../../../../../constants/dateFormat";
import { FilterOption } from "../../../../filterPopup.models";
import styles from "./filterBodyItem.module.css";

const { RangePicker } = DatePicker;

interface FilterBodyItemProps {
    filterOptions: FilterOption;
}

export const FilterBodyItem = ({ filterOptions }: FilterBodyItemProps) => {
    const {
        label,
        type,
        options,
        value,
        handleChange,
        checkboxValue,
        handleCheckboxChange,
        customStartDate,
        customEndDate,
        onCustomRangeChange,
    } = filterOptions;

    if (type === "select") {
        return (
            <div className={styles.filterBodyItemCtn}>
                <span className={styles.filterBodyItemTitleText}>{label}</span>
                <Select
                    classNames={{ popup: { root: styles.selectPopup, listItem: styles.selectListItem } }}
                    className={styles.selectRoot}
                    options={options}
                    mode="multiple"
                    placeholder={`Select a ${label}`}
                    allowClear
                    showSearch
                    filterOption={filterOptionForSearch}
                    onChange={handleChange}
                    value={value}
                    size="large"
                />
            </div>
        );
    }

    if (type === "date") {
        return (
            <div className={styles.filterBodyItemCtn}>
                <span className={styles.filterBodyItemTitleText}>{label}</span>
                <Select
                    classNames={{ popup: { root: styles.selectPopup, listItem: styles.selectListItem } }}
                    className={styles.selectRoot}
                    options={options}
                    placeholder={`Select a ${label}`}
                    allowClear
                    showSearch
                    filterOption={filterOptionForSearch}
                    onChange={handleChange}
                    value={value}
                    size="large"
                />
                {value === "custom" && (
                    <RangePicker
                        classNames={{ popup: { root: styles.selectPopup }, root: styles.selectRoot }}
                        size="large"
                        value={
                            customStartDate && customEndDate
                                ? [dayjs(customStartDate), dayjs(customEndDate)]
                                : null
                        }
                        onChange={(dates) => {
                            if (dates?.[0] && dates?.[1]) {
                                onCustomRangeChange?.(
                                    dates[0].format(DateFormat.YYYY_MM_DD),
                                    dates[1].format(DateFormat.YYYY_MM_DD)
                                );
                            } else {
                                onCustomRangeChange?.(null, null);
                            }
                        }}
                        format={DateFormat.MM_DD_YYYY}
                    />
                )}
            </div>
        );
    }

    if (type === "text") {
        return (
            <div className={styles.filterBodyItemCtn}>
                <span className={styles.filterBodyItemTitleText}>{label}</span>
                <Input
                    className={styles.textInputRoot}
                    placeholder={`Search ${label}`}
                    allowClear
                    value={typeof value === "string" ? value : ""}
                    onChange={(event) => handleChange?.(event.target.value)}
                    size="large"
                />
            </div>
        );
    }

    if (type === "checkbox") {
        return (
            <div className={styles.filterBodyCheckboxCtn}>
                <Checkbox
                    checked={checkboxValue}
                    onChange={(e) => handleCheckboxChange?.(e.target.checked)}
                    className={styles.filterBodyCheckbox}
                >
                    {label}
                </Checkbox>
            </div>
        );
    }

    return null;
};
